import AmexGDAOffersCards from './AmexGDAOffersCards';

export default AmexGDAOffersCards;
